import FeatherIcon from 'feather-icons-react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Option } from 'react-bootstrap-typeahead/types/types';

export interface OutletOption {
  id?: string;
  name: string;
}

export interface SelectionGroup {
  id: number;
  selectedOutlet: OutletOption | null;
  amount: number | null;
  prefilled: boolean;
}

const OutletsOwedForm = ({
  selectionGroups,
  onOutletChanged,
  outletOptions,
  onOwedAmountChanged,
  handleAddOutlet,
  handleRemoveOutlet
}: {
  selectionGroups: SelectionGroup[];
  onOutletChanged: (id: number, seletced: Option[]) => void;
  outletOptions: Option[];
  onOwedAmountChanged: (id: number, value: number) => void;
  handleAddOutlet: () => void;
  handleRemoveOutlet: (id: number) => void;
}) => {
  return (
    <>
      {selectionGroups.map((group, index) => {
        // const isRemoveButtonEnabled = group.selectedOutlet !== null && group.amount !== null;
        return (
          <Row key={group.id} className="mb-3">
            <Col xs={12} md={6}>
              <Form.Group className="form-group">
                <Form.Label>Outlet name</Form.Label>
                <Typeahead
                  id={`outlet-typeahead-${group.id}`}
                  labelKey="name"
                  onChange={selected => onOutletChanged(group.id, selected)}
                  options={outletOptions}
                  placeholder="Select outlet..."
                  multiple={false}
                  selected={group.selectedOutlet ? [group.selectedOutlet] : []}
                  disabled={group.prefilled}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Row>
                <Col xs={8}>
                  <Form.Group>
                    <Form.Label>Amount owed</Form.Label>
                    <Form.Control
                      type="number"
                      value={group.amount || ''}
                      onChange={e => onOwedAmountChanged(group.id, Number(e.target.value))}
                      id={`amount-${group.id}`}
                    />
                  </Form.Group>
                </Col>

                <Col xs={4} className="d-flex align-items-end">
                  {index === selectionGroups.length - 1 && !group.prefilled ? (
                    <Button variant="primary" onClick={handleAddOutlet}>
                      Add
                    </Button>
                  ) : (
                    group.selectedOutlet &&
                    group.amount !== null &&
                    group.amount !== undefined && (
                      <span role="button" style={{ color: 'red' }} onClick={() => handleRemoveOutlet(group.id)}>
                        <FeatherIcon icon="x" size="25" />
                      </span>
                    )
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default OutletsOwedForm;
